import styled from "styled-components";
const RightPartInner = styled.div`
`;
export default RightPartInner;